<template>
  <div class="home">
    <!--导航栏-->
    <nav class="navbar navbar-default head_nav" role="navigation" style="padding: 0px !important;">
      <div class="container-fluid content_wrapper">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle" data-toggle="collapse"
                  data-target="#example-navbar-collapse">
            <span class="sr-only">切换导航</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand head_logo" href="javascript:void(0)">
            <img src="../assets/images/logo2.png" @click="refreshVue()" />
          </a>
        </div>
        <div class="collapse navbar-collapse" id="example-navbar-collapse">
          <ul class="nav navbar-nav nav_total">
            <li class=''><a href="javascript:void(0)" style="font-weight: unset;" @click="refreshVue()">智慧停车</a></li>
            <!--                <li class=''><a href="Index.aspx">解决方案</a></li>-->
            <!--                <li class=''><a href="Case.aspx">经典案例</a></li>-->
            <!--                <li class='dropdown '>-->
            <!--                    <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">关于我们</a>-->
            <!--                    <ul class="dropdown-menu">-->
            <!--                        <li><a href="AboutUs.aspx">关于云凯</a></li>-->
            <!--                        <li><a href="AboutTeam.aspx">云凯团队</a></li>-->
            <!--                        <li><a href="AboutNews.aspx">新闻动态</a></li>-->
            <!--                        <li><a href="Contact.aspx">加入我们</a></li>-->
            <!--                        <li><a href="ContantAddress.aspx">联系我们</a></li>-->
            <!--                    </ul>-->
            <!--                </li>-->
            <!--                <li class=''><a href="Joint.aspx">招商加盟</a></li>-->
          </ul>
        </div>
      </div>
    </nav>


    <!--中间banner区域-->



    <!--轮播图区域-->
    <div id="myCarousel" class="carousel slide index_slide">
      <!-- 轮播（Carousel）指标 -->
      <!-- <ol class="carousel-indicators slide_page">
      <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
      <li data-target="#myCarousel" data-slide-to="1"></li>
      <li data-target="#myCarousel" data-slide-to="2"></li>
    </ol>    -->
      <!-- 轮播（Carousel）项目 -->

      <div class="carousel-inner slide_content_total">
        <!--第一个轮播图-->
        <div class="item active first_slide">
          <img src="../assets/images/banner333.png" class="img-responsive" />
        </div>
        <!--第一个轮播图结束-->


      </div>
    </div>


    <!--旗下产品-->
    <article class="container-fluid index_first_article">
      <div class="content_wrapper">
        <!--标题区域-->
        <div class="index_first_title" style="margin-bottom: 0px;">
          <!-- <img  src="images/index_first.png"/> -->
          <h2>建设目标</h2>
          <h6>productsof the corporation</h6>
        </div>
        <div class="row index_first_list">
          <div class="col-md-2 col-sm-6">
            <div class="index_first_content">
              <img src="../assets/images/update15.png" />
              <h3>政府规划</h3>
              <p>分析泊位使用规律和走势
                <br>
                整合建设停车资源</p>
            </div>
          </div>

          <div class="col-md-2 col-sm-6">
            <div class="index_first_content">
              <img src="../assets/images/update16.png" />
              <h3>企业运营</h3>
              <p>减少人工
                <br>
                降低成本
                <br>
                高效管理</p>
            </div>
          </div>

          <div class="col-md-2 col-sm-6">
            <div class="index_first_content">
              <img src="../assets/images/update5.png" />
              <h3>停车场管理</h3>
              <p>获取经营报表<br>
                盈利跟踪
                <br>
                后续投资数据支持</p>
            </div>
          </div>

          <div class="col-md-2 col-sm-6">
            <div class="index_first_content">
              <img src="../assets/images/update3.png" />
              <h3>治安防控</h3>
              <p>掌握各停车场信息提供车牌号<br>
                、图片、视频监控信息</p>
            </div>
          </div>

          <div class="col-md-2 col-sm-6">
            <div class="index_first_content">
              <img src="../assets/images/update2.png" />
              <h3>便捷泊车</h3>
              <p>实时获取泊车数据<br>
                多种支付渠道<br>
                优惠支持</p>
            </div>
          </div>

          <div class="col-md-2 col-sm-6">
            <div class="index_first_content">
              <img src="../assets/images/update4.png" />
              <h3>交通疏导</h3>
              <p>整合车位数据<br>
                助理交通治理<br>
                缓解停车压力</p>
            </div>
          </div>


        </div>
      </div>
    </article>

    <!--解决方案-->
    <article class="index_first_article pray_bg container-fluid">
      <div class="content_wrapper">
        <!--标题区域-->
        <div class="index_first_title">
          <h2>城市级智慧停车平台 </h2>
          <h6>真正智能化、无人化收费停车值守统</h6>
          <div class="index_first_333">
            <div class="col-md-4">
              <span>0投入</span>
            </div>
            <div class="col-md-4">
              <span>0风险</span>
            </div>
            <div class="col-md-4">
              <span>0收费人员</span>
            </div>
          </div>

          <!-- <p class="index_title_supply">在已有或新建的独立楼宇、地块、区域智能化建设的基础上，
      整合所有独立的基础架构、管理系统、应用模块，提供统一的运营、管理、用户以及智慧服务。
    </p> -->
        </div>

        <div class="index_second_content" style="text-align: left">
          <div class="row index_second_row">
            <div class="col-md-6  col-sm-5 ">
              <ul class="update_ul">
                <li>
                  <span></span>
                  <label>改变传统停车效率低、成本高难题</label>
                  <p>路边占道智慧停车管理：效率提升200%</p>
                </li>
                <li>
                  <span></span>
                  <label>改变传统停车效率低、成本高难题</label>
                  <p>远程监控<br>
                    线下线上支付联动
                    <br>
                    数据全记录</p>
                </li>
              </ul>
            </div>
            <div class="col-md-6 col-sm-7 update_ul_background">
              <ul class="update_ul ">
                <li>
                  <span></span>
                  <label>为车主提供便捷的停车体验</label>
                  <p>车主自助服务
                    <br>
                    互联网支付体验  </p>
                </li>
                <li>
                  <span></span>
                  <label>精准的大数据分析</label>
                  <p>路边与封闭停车数据联动  |   停车数据发布<br>
                    车位共享、P+生态对接平台
                    <br>
                  </p>
                  <!--                                交通信息共享-->
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </article>

    <!--智慧停车-->
    <article class="container-fluid index_first_article">
      <div class="content_wrapper">
        <!--标题区域-->
        <div class="index_first_title">
          <h2>智慧停车 </h2>
          <h6>功能特色（智能无人版）</h6>

        </div>
        <div class="index_first_444" style="text-align: left">
          <div class="col-md-4">
            <img src="../assets/images/111.png" alt="">
          </div>
          <div class="col-md-4">
            <ul class="update_ul ">
              <li>
                <span></span>
                <label>无人化</label>
                <p>岗亭无人值守  远程实时监控
                  <br>
                  异常应急管理  智能引导 </p>
              </li>
              <li>
                <span></span>
                <label>岗亭云端化</label>
                <p>云端客服中心  |   实时监控停车场<br>
                  异常通行远程5s受理
                  <br>
                  7*24h 服务  </p>
              </li>
            </ul>
          </div>
          <div class="col-md-4">
            <ul class="update_ul ">
              <li>
                <span></span>
                <label>无中心化</label>
                <p>卡片电脑分布式计算，可脱网运行</p>
              </li>
              <li>
                <span></span>
                <label>移动化</label>
                <p>业主自助app     微信服务公众号  保安应急管理app   </p>
              </li>
              <li>
                <span></span>
                <label>智能化</label>
                <p>车牌智能识别系统        智能人脸识别系统
                  <br>
                  智能车主互动系统        扫码无牌 非机动车通行</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </article>

    <!--新闻资讯-->
    <article class="index_first_article pray_bg container-fluid">
      <div class="content_wrapper">
        <!--标题区域样式-->

        <div class="row index_news_content index_news_content2">
          <div class="col-md-6">
            <h3>智慧停车App</h3>
            <span>智慧停车互联网体验  </span>
            <p>车主通过APP或微信可实现泊位查询、泊位预约、泊位导航、欠费补缴，快速充值、电 子发票、充电查询、充电预约、充电控制、充电导航</p>
            <img src="../assets/images/update77.png" alt="">
          </div>
          <div class="col-md-6">
            <h3>智慧停车</h3>
            <span>P+生态开发拓展平台  </span>
            <p>基于停车行为，链接到车主本地化生活，为车主打造智慧化生活圈。  </p>
            <img src="../assets/images/update8.png" alt="">
          </div>
        </div>
      </div>
    </article>
    <!--智慧停车-->
    <article class="container-fluid index_first_article">
      <div class="content_wrapper">
        <!--标题区域-->
        <div class="index_first_title" style="margin-bottom: 30px;">
          <h2>智慧停车 </h2>
          <h6>云客服|云监管|大数据</h6>

        </div>
        <div class="index_first_444">
          <div class="col-md-4">
            <div class="yinyin">
              <h3>城市停车运营平台</h3>
              <img src="../assets/images/update100.png" alt="">
            </div>

          </div>
          <div class="col-md-4">
            <div class="yinyin">
              <h3>城市停车运营平台</h3>
              <img src="../assets/images/update90.png" alt="">
            </div>
          </div>
          <div class="col-md-4">
            <div class="yinyin">
              <h3>城市停车运营平台</h3>
              <img src="../assets/images/update111.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </article>
    <!--智慧停车-->
    <article class="index_first_article pray_bg container-fluid">
      <div class="content_wrapper">
        <!--标题区域-->
        <div class="index_first_title" style="margin-bottom: 30px;">
          <h2>案例介绍  </h2>
          <h6>公共，园区，路内全场景覆盖</h6>

        </div>
        <div class="index_first_444">
          <div class="col-md-4">
            <div class="yinyin">

              <img src="../assets/images/update122.jpg" alt="">
              <h3>金昌市上海路高杆</h3>
            </div>

          </div>
          <div class="col-md-4">
            <div class="yinyin">

              <img src="../assets/images/update144.jpg" alt="">
              <h3>昌丰里社区公共停车场</h3>
            </div>
          </div>
          <div class="col-md-4">
            <div class="yinyin">

              <img src="../assets/images/update133.jpg" alt="">
              <h3>金昌市城市基础设施调度服务中心</h3>
            </div>
          </div>
        </div>
      </div>
    </article>

    <!--底部区域-->

    <!--底部导航-->
    <footer class="bottom_total">
      <!--导航链接区域-->
      <div class="bottom_nav_total">
        <div class="content_wrapper clearfix" style="display: flex;justify-content: center;">
          <!--导航链接区域-->
          <ul class="bottom_nav" style="display: flex;justify-content: center">
            <!--                <li>-->
            <!--                    <h1>技术产品</h1>-->
            <!--                    <a href="Index.aspx">技术产品</a>-->
            <!--                    <a href="Index.aspx">应用产品</a>-->
            <!--                    <a href="Index.aspx">解决方案</a>-->
            <!--                    <a href="Index.aspx">互联网产品</a>-->
            <!--                    <span class="bottom_border"></span>-->
            <!--                </li>-->

            <li>
              <h1>关于我们</h1>
              <a href="http://www.jcszhtc.com">路建简介</a>
              <a href="http://jcszhtc.com/glgc/">公司动态</a>
              <span class="bottom_border"></span>
            </li>

            <!--                <li>-->
            <!--                    <h1>解决方案</h1>-->
            <!--                    <a href="IndexDataOffice.aspx">网信</a>-->
            <!--                    <span class="bottom_border"></span>-->
            <!--                </li>-->

            <!--                <li>-->
            <!--                    <h1>智慧停车</h1>-->
            <!--                    <a href="" target="_blank">智慧停车</a>-->
            <!--                    <a href="">大数据平台</a>-->
            <!--                    <span class="bottom_border"></span>-->
            <!--                </li>-->

            <!--                <li>-->
            <!--                    <h1>人才招聘</h1>-->
            <!--                    <a href="">人才招聘</a>-->
            <!--                    <span class="bottom_border"></span>-->
            <!--                </li>-->

            <li>
              <h1>友情链接</h1>
              <a href="http://www.jcszhtc.com" target="_blank">友情链接</a>
            </li>
          </ul>

          <!--二维码区域-->
          <!--            <div class="bottom_code">-->
          <!--                <p class="bottom_code_img">-->
          <!--                    <img src="images/yk_code.png" />-->
          <!--                </p>-->
          <!--                <p class="bottom_code_text">微信公众号</p>-->
          <!--            </div>-->
        </div>
      </div>
      <!--版权区域-->
      <div class="bottom_copyright">
        <p class="content_wrapper bottom_copyright_text">Copyright ©2023 金昌路建工程管理有限责任公司 版权所有
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">陇ICP备2022003198号-1</a>
        </p>
      </div>
    </footer>
  </div>
</template>


<!--jquery-->
<script type="text/javascript" src="../assets/js/jquery.js"></script>
<!--boostrap js-->
<script type="text/javascript" src="../assets/js/bootstrap.min.js"></script>
<!--地图-->
<script type="text/javascript" src="http://api.map.baidu.com/api?key=&v=1.1&services=true"></script>
<!--swiper js-->
<script type="text/javascript" src="../assets/js/swiper.min.js"></script>
<!--多行文本溢出插件-->
<script type="text/javascript" src="../assets/js/jquery.dotdotdot.js"></script>
<!--本页面js-->
<script type="text/javascript" src="../assets/js/website.js"></script>


<script>

export default {
  name: 'HomeView',
  components: {
    // HelloWorld
  },
  methods: {
    refreshVue() {
      this.$router.go(0)
    },
    aaaaaa() {

    }
  }
}
</script>



